import { cn } from "../../utils";

export interface SkeletonProps {
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
  return (
    <div
      className={cn(
        "ui:h-4 ui:w-17.5 ui:animate-pulse ui:rounded-sm ui:bg-divider",
        className,
      )}
    />
  );
};
